const route = {
	path: '/login/:token?',
	name: 'login',
	meta: {
		title: 'Iniciar Sesión',
	},
	props: true,
	component: () => import('@/pages/page-login'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/login.js